import { CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DialogProviderAuthorization } from "../../../components/common/DialogProviderAuthorization";
import UserContext from "../../../context/user-context";
import useProviderAuthorization from "../../../hooks/useProviderAuthorization";
import { useStore } from "../../../hooks/useStore";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  getLotsOfCountry,
  getResidentsOfCountry,
} from "../../../redux/actions/authActions";
import { addAuthorization } from "../../../store/actions/userAction";
import { convertAuthorization } from "../../../store/functions/userFunction";
import { AuthorizationType } from "../../../store/types/userTypes";
import { getResidentPassInformation, queryParse } from "../../../utils/Parses";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";
import { useStyles } from "./SearchAuthorizationsStyles";

interface DialogProviderAuthorization {
  open: boolean;
  providers: any[];
  lotName: string;
}

const SearchAuthorizations = () => {
  const classes = useStyles();
  const [options, setOptions] = React.useState<any[]>([]);
  const [value, setValue] = useState("");
  const { authStore } = useStore();
  const globalDispatch = useDispatch();
  const { state, dispatch } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();
  const [residentsArray, setResidentsArray] = useState<any[]>([]);
  const [standByDecision, setStandByDecision] = useState<any>(null);
  const { loading, dialogState, checkProviderAuthorization, reset } =
    useProviderAuthorization();
  useEffect(() => {
    if (authStore.residents) {
      setResidentsArray(authStore.residents);
    }
  }, [JSON.stringify(authStore.residents)]);
  const searchHiddenLots = (): any[] => {
    const lots = authStore.lots;
    const lotsHidden = lots.filter((lot) => {
      let flag: boolean = false;
      flag = residentsArray.some(
        (resident) => lot.id === resident?.residencesInfo[0]?.lotInfo?.id
      );
      if (!flag) {
        return lot;
      }
    });
    return lotsHidden;
  };
  const handleChange = (value: string) => {
    let residents: any[] = [];
    if (value !== "") {
      let hidden = searchHiddenLots();
      residents = [...residentsArray];
      hidden.map((item) => {
        residents.push({
          id: item.id,
          customLot: item.name,
          residencesInfo: [
            {
              lotInfo: {
                id: item.id,
                name: item.name,
                description: item.description,
                phone: item.phone,
              },
            },
          ],
        });
      });
      setOptions(residents);
    }
  };
  const handleMark = async (event: any, newValue: any) => {
    setValue(Math.random().toString());
    let host,
      lot = "";
    if (newValue.customLot) lot = newValue.id;
    else host = newValue.id;
    setStandByDecision(newValue);
    await checkProviderAuthorization(newValue, host, lot, () => {
      addAuthorizationGuard(newValue);
    });
  };

  const addAuthorizationGuard = (newValue: any) => {
    dispatch(
      addAuthorization(
        convertAuthorization(
          {
            host: newValue,
            id: newValue.id,
          },
          {
            type: AuthorizationType.authorizedOnGuard,
            mark: true,
            guestType: state.lastSelectionAuthorizationType,
          }
        )
      )
    );
  };

  const actionCancel = () => {
    addAuthorizationGuard(standByDecision);
    setStandByDecision(null);
  };

  const refreshResidents = () => {
    getResidentsOfCountry(authStore.token, globalDispatch);
    getLotsOfCountry(authStore.token, globalDispatch);
  };
  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={(e) => {
        // Sin esto, si el buscador no llega a resaltar ninguna opción (recién tipeando, sin
        // resultados todavía), Enter cae al submit nativo del form: dispara una navegación real
        // que el `beforeunload` de Dashboard intercepta con el popup de "salir de la página".
        e.preventDefault();
      }}
    >
      <Autocomplete
        id="asynchronous-demo"
        className={classes.search}
        key={value}
        autoHighlight
        noOptionsText={t(BundleKey.DETAIL_AUTHORIZATION_SEARCH_NOTFOUND)}
        onChange={handleMark}
        onInputChange={(event, newInputValue) => {
          handleChange(newInputValue);
        }}
        onBlur={() => setOptions([])}
        getOptionSelected={() => true}
        getOptionLabel={(option: any) => queryParse(option)}
        options={options}
        forcePopupIcon={false}
        renderOption={(option) => getResidentPassInformation(option)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t(BundleKey.DETAIL_AUTHORIZATION_SEARCH_PLACEHOLDER)}
            variant="outlined"
            fullWidth
            onFocus={refreshResidents}
            inputProps={{
              ...params.inputProps,
              tabIndex: state.config?.companion
                ? CompanionTabIndex.search
                : EntrantTabIndex.search,
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress style={{ width: 20, height: 20 }} />
                  ) : (
                    params.InputProps.endAdornment
                  )}
                </>
              ),
            }}
          />
        )}
      />
      <DialogProviderAuthorization
        open={dialogState.open}
        close={reset}
        providers={dialogState.providers}
        lotName={dialogState.lotName}
        actionCancel={actionCancel}
      />
    </form>
  );
};

export default SearchAuthorizations;
